export default __webpack_public_path__ + "static/media/logo-synapse24x24.e2f6e931.svg";